module.exports = __webpack_public_path__ + "img/9D9D9D_4E4E4E_646464_6C6C6C-256px.e191c43c.png";